import React from "react";
import { AiFillGithub, AiOutlineTwitter, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

const MAP = {
  github: AiFillGithub,
  twitter: AiOutlineTwitter,
  instagram: AiFillInstagram,
  linkedin: FaLinkedinIn,
};

export default function SocialIcon({ name, className = "" }) {
  const Icon = MAP[name] || AiFillGithub;
  return <Icon className={className} />;
}
